import request from './request'
// ------------------------------基本信息
// 课程简介
export const editcourseIntroduce = (data) => {
  return request({
    url: '/classspace/course/courseIntroduce/',
    data,
    method: 'post',
  })
}
// 补充信息
export const editcourseInformation = (data) => {
  return request({
    url: '/classspace/course/courseInformation',
    data,
    method: 'post',
  })
}
// 评分标准
export const editcourseStandard = (data) => {
  return request({
    url: '/classspace/course/courseStandard',
    data,
    method: 'post',
  })
}
// 查看详情
export const getlist = (id) => {
  return request({
    url: '/classspace/course/courseIdList/' + id,
    method: 'post',
  })
}
// 删除教材
export const delcourseStandard = (id) => {
  return request({
    url: '/classspace/course/courseMaterialDel/' + id,
    method: 'delete',
  })
}
// 添加教材
export const addcourseMaterialAdd = (id, data) => {
  return request({
    url: '/classspace/course/courseMaterialAdd/' + id,
    data,
    method: 'post',
  })
}
// 查询教材列表
export const getcourseMaterialListById = (id) => {
  return request({
    url: '/classspace/course/courseMaterialList/' + id,
    method: 'post',
  })
}
// 修改教材
export const editcourseMaterialUpd = (data) => {
  return request({
    url: '/classspace/course/courseMaterialUpd',
    data,
    method: 'post',
  })
}
// ----------------------------团队
// 所有教师列表
export const getteacherList = (data) => {
  return request({ url: '/classspace/team/usersListReq', data, method: 'post' })
}
// 团队教师列表
export const getteamteacherList = (id) => {
  return request({ url: '/classspace/team/usersList/' + id, method: 'get' })
}
// 批量添加教师
export const addteam = (data) => {
  return request({
    url: '/classspace/team/usersListPost',
    data,
    method: 'post',
  })
}
// 批量删除教师
export const delteam = (data) => {
  return request({
    url: '/classspace/team/middleUsersDel',
    data,
    method: 'post',
  })
}
// --------------------------------------------------------------------------互动
// 新增互动
export const discussAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/discussAdd/' + id,
    data,
    method: 'post',
  })
}
// 编辑互动
export const discussUpd = (data) => {
  return request({
    url: '/classspace/interaction/discussUpd',
    data,
    method: 'post',
  })
}
// 删除互动
export const discussDel = (id) => {
  return request({
    url: '/classspace/interaction/discussDel/' + id,
    method: 'delete',
  })
}
// 新增测验
export const voteAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/voteAdd/' + id,
    data,
    method: 'post',
  })
}
// // 编辑测验
export const voteUpd = (data) => {
  return request({
    url: '/classspace/interaction/voteUpd',
    data,
    method: 'post',
  })
}
export const modifyTrainingTest = (data) => {
  return request({
    url: `classspace/interaction/modifyTrainingTest`,
    data,
    method: 'post',
  })
}

// 编辑选项
export const batchUpdateVotePollTypes = (data) => {
  return request({
    url: '/classspace/interaction/batchUpdateVotePollTypes',
    data,
    method: 'post',
  })
}
// 删除测验
export const voteDel = (id) => {
  return request({
    url: '/classspace/interaction/voteDel/' + id,
    method: 'delete',
  })
}
// // 测验列表
export const voteList = (id, data) => {
  return request({
    url: '/classspace/interaction/voteList/' + id,
    method: 'post',
    data,
  })
}
//
export const voteTest = (voteId) => {
  return request({
    url: '/classspace/interaction/voteTest',
    method: 'get',
    params: { voteId },
  })
}
// 讨论列表
export const discussList = (id, data) => {
  return request({
    url: '/classspace/interaction/discussList/' + id,
    data,
    method: 'post',
  })
}
// 新增提问
export const questionsAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/questionsAdd/' + id,
    data,
    method: 'post',
  })
}
// 提问列表
export const questionsList = (id, data) => {
  return request({
    url: '/classspace/interaction/questionsList/' + id,
    data,
    method: 'post',
  })
}
// 修改提问
export const questionsUpd = (data) => {
  return request({
    url: '/classspace/interaction/questionsUpd',
    data,
    method: 'post',
  })
}
// 删除提问
export const questionsDel = (id) => {
  return request({
    url: '/classspace/interaction/questionsDel/' + id,
    method: 'delete',
  })
}
// 头脑风暴列表
export const brainstormingList = (id, data) => {
  return request({
    url: '/classspace/interaction/brainstormingList/' + id,
    data,
    method: 'post',
  })
}
// 新增头脑风暴
export const brainstormingAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/brainstormingAdd/' + id,
    data,
    method: 'post',
  })
}
// 编辑头脑风暴
export const brainstormingUpd = (data) => {
  return request({
    url: '/classspace/interaction/brainstormingUpd',
    data,
    method: 'post',
  })
}
// 删除头脑风暴
export const brainstormingDel = (id) => {
  return request({
    url: '/classspace/interaction/brainstormingDel/' + id,
    method: 'delete',
  })
}
// 小组pk列表
export const groupPkList = (id, data) => {
  return request({
    url: '/classspace/interaction/groupPkList/' + id,
    data,
    method: 'post',
  })
}
// 新增小组pk
export const groupPkAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/groupPkAdd/' + id,
    data,
    method: 'post',
  })
}
// 编辑小组pk
export const groupPkUpd = (data) => {
  return request({
    url: '/classspace/interaction/groupPkUpd',
    data,
    method: 'post',
  })
}
// 删除小组pk
export const groupPkDel = (id) => {
  return request({
    url: '/classspace/interaction/groupPkDel/' + id,
    method: 'delete',
  })
}
// 新增测验
export const experimentAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/experimentAdd/' + id,
    data,
    method: 'post',
  })
}
// 删除测验
export const experimentDel = (id) => {
  return request({
    url: '/classspace/interaction/experimentDel/' + id,
    method: 'delete',
  })
}
// 测验列表
export const experimentList = (id, data) => {
  return request({
    url: '/classspace/interaction/experimentList/' + id,
    data,
    method: 'post',
  })
}
// 新增实训测验
export const experimentTrainAdd = (id, data) => {
  return request({
    url: '/classspace/interaction/experimentPostAdd/' + id,
    data,
    method: 'post',
  })
}
// --------------------------------------------------------------------------直播
// 插入直播
export const insertStreaming = (data) => {
  return request({
    url: '/classspace/streaming/insertStreaming',
    data,
    method: 'post',
  })
}
// 修改直播
export const xiugaiStreaming = (data) => {
  return request({
    url: '/classspace/streaming/xiugaiStreaming',
    data,
    method: 'post',
  })
}
// 删除直播
export const deleteStreaming = (params) => {
  return request({
    url: '/classspace/streaming/deleteStreaming',
    params,
    method: 'delete',
  })
}
// 直播列表
export const getStreaming = (data) => {
  return request({
    url: '/classspace/streaming/getStreaming',
    data,
    method: 'post',
  })
}
// 删除直播
export const delStreaming = (params) => {
  return request({
    url: '/classspace/streaming/getStreaming',
    params,
    method: 'get',
  })
}
// --------------------------------------------------------------------------课件
// 课件列表
export const coursewareList = (id, data) => {
  return request({
    url: '/classspace/courseware/coursewareList/' + id,
    data,
    method: 'post',
  })
}
// 新增文件夹
export const coursewareFolderAdd = (id, data) => {
  return request({
    url: '/classspace/courseware/coursewareFolderAdd/' + id,
    data,
    method: 'post',
  })
}
// 批量删除课件
export const coursewareDel = (params) => {
  return request({
    url: '/classspace/courseware/coursewareDel',
    params,
    method: 'post',
  })
}
// 查询文件夹
export const coursewareFolderList = (coursewareId) => {
  return request({
    url: '/classspace/courseware/coursewareFolderList/' + coursewareId,
    method: 'post',
  })
}
// 添加链接
export const coursewareLinkAdd = (coursewareId, data) => {
  return request({
    url: '/classspace/courseware/coursewareLinkAdd/' + coursewareId,
    data,
    method: 'post',
  })
}
// 重命名
export const coursewareUpd = (data) => {
  return request({
    url: '/classspace/courseware/coursewareUpd',
    data,
    method: 'post',
  })
}
// 添加标签
export const coursewareLabelAdd = (coursewareId, data) => {
  return request({
    url: '/classspace/courseware/coursewareLabelAdd/' + coursewareId,
    data,
    method: 'post',
  })
}
// 时间正序展示列表
export const coursewareDateList = (coursewareId, params) => {
  return request({
    url: '/classspace/courseware/coursewareDateList/' + coursewareId,
    params,
    method: 'post',
  })
}
// 时间倒序展示列表
export const coursewareDateDescList = (coursewareId, params) => {
  return request({
    url: '/classspace/courseware/coursewareDateDescList/' + coursewareId,
    params,
    method: 'post',
  })
}
// 添加原创标签类型
export const sourceOriginalAdd = (coursewareId, data) => {
  return request({
    url: '/classspace/courseware/sourceOriginalAdd/' + coursewareId,
    data,
    method: 'post',
  })
}
// 本地课件上传
export const fileUpload = (id, file) => {
  return request({
    url: '/classspace/courseware/fileUpload/' + id,
    data: file,
    method: 'post',
    headers: {
      'Content-type': 'multipart/form-data',
    },
  })
}
// 文件夹下新建文件夹
export const coursewareFolderAgainAdd = (id, coursewareId, data) => {
  return request({
    url:
      '/classspace/courseware/coursewareFolderAgainAdd/' +
      id +
      '/' +
      coursewareId,
    data,
    method: 'post',
  })
}
// 文件下添加链接
export const coursewareLinkAgainAdd = (id, coursewareId, data) => {
  return request({
    url:
      '/classspace/courseware/coursewareLinkAgainAdd/' +
      id +
      '/' +
      coursewareId,
    data,
    method: 'post',
  })
}
// 文件夹下上传文件
export const fileAgainUpload = (id, coursewareId, data) => {
  return request({
    url: '/classspace/courseware/fileAgainUpload/' + id + '/' + coursewareId,
    data,
    method: 'post',
    headers: {
      'Content-type': 'multipart/form-data',
    },
  })
}
// --------------------------------------------------------------------------课件
// 添加章节
export const categoryAdd = (id, data) => {
  return request({
    url: '/classspace/category/categoryAdd/' + id,
    data,
    method: 'post',
  })
}
// 章节列表
export const categoryList = (id, data) => {
  return request({
    url: '/classspace/category/categoryList/' + id,
    data,
    method: 'post',
  })
}
// 修改章节
export const categoryUpd = (data) => {
  return request({
    url: '/classspace/category/categoryUpd',
    data,
    method: 'post',
  })
}
// 删除章节
export const categoryDel = (id) => {
  return request({
    url: '/classspace/category/categoryDel/' + id,
    method: 'post',
  })
}
// 添加小节
export const sectionAdd = (id, data) => {
  return request({
    url: '/classspace/category/sectionAdd/' + id,
    data,
    method: 'post',
  })
}
// 小节列表
export const sectionList = (id) => {
  return request({
    url: '/classspace/category/sectionList/' + id,
    method: 'post',
  })
}
// 修改小节
export const sectionUpd = (data) => {
  return request({
    url: '/classspace/category/sectionUpd',
    data,
    method: 'post',
  })
}
// 删除小节
export const sectionDel = (id) => {
  return request({
    url: '/classspace/category/sectionDel/' + id,
    method: 'post',
  })
}
// 小节下互动列表
export const sectionInteractionList = (id) => {
  return request({
    url: '/classspace/category/sectionInteractionList/' + id,
    method: 'post',
  })
}
// 小节下文件上传
export const nodefileUpload = (id, coursewareId, data) => {
  return request({
    url: '/classspace/category/fileUpload/' + id + '/' + coursewareId,
    data,
    method: 'post',
    headers: {
      'Content-type': 'multipart/form-data',
    },
  })
}
// 小节课件列表
export const selectCourseCategory = (data) => {
  return request({
    url: '/classspace/category/selectCourseCategory',
    data,
    method: 'post',
  })
}
// 小节添加课件
export const sectionCoursewareAdd = (data) => {
  return request({
    url: '/classspace/category/sectionCoursewareAdd',
    data,
    method: 'post',
  })
}
// 小节测验列表
export const selectExperiment = (id, data) => {
  return request({
    url: '/classspace/category/selectExperiment/' + id,
    data,
    method: 'post',
  })
}
// 小节添加测验
export const sectionExperimentAdd = (id, coursewareId, params) => {
  return request({
    url: '/classspace/category/sectionExperimentAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 小节作业列表
export const selectOperation = (id, data) => {
  return request({
    url: '/classspace/category/selectOperation/' + id,
    data,
    method: 'post',
  })
}
// 小节添加作业
export const sectionOperationAdd = (id, coursewareId, params) => {
  return request({
    url: '/classspace/category/sectionOperationAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 小节讨论列表
export const selectDiscussCategory = (id, data) => {
  return request({
    url: '/classspace/category/selectDiscussCategory/' + id,
    data,
    method: 'post',
  })
}
// 小节添加讨论
export const sectionDiscussAdd = (id, coursewareId, params) => {
  return request({
    url: '/classspace/category/sectionDiscussAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 小节投票列表
export const selectVote = (id, data) => {
  return request({
    url: '/classspace/category/selectVote/' + id,
    data,
    method: 'post',
  })
}
// 小节添加投票
export const sectionVoteAdd = (id, coursewareId, params) => {
  return request({
    url: '/classspace/category/sectionVoteAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 小节头脑风暴列表
export const selectBrainstorming = (id, data) => {
  return request({
    url: '/classspace/category/selectBrainstorming/' + id,
    data,
    method: 'post',
  })
}
// 小节添加头脑风暴
export const sectionBrainstormingAdd = (id, coursewareId, params) => {
  return request({
    url:
      '/classspace/category/sectionBrainstormingAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 小节提问列表
export const selectQuestions = (id, data) => {
  return request({
    url: '/classspace/category/selectQuestions/' + id,
    data,
    method: 'post',
  })
}
// 小节添加提问
export const sectionQuestionsAdd = (id, coursewareId, params) => {
  return request({
    url: '/classspace/category/sectionQuestionsAdd/' + id + '/' + coursewareId,
    params,
    method: 'post',
  })
}
// 删除小节下资源
export const sectionInteractionDel = (id) => {
  return request({
    url: '/classspace/category/sectionInteractionDel/' + id,
    method: 'post',
  })
}
// 小节添加图文
export const sectionGraphicAdd = (id, data) => {
  return request({
    url: '/classspace/category/sectionGraphicAdd/' + id,
    data,
    method: 'post',
  })
}
// 查询详情
export const selectInteractionList = (data) => {
  return request({
    url: '/classspace/category/selectInteractionList',
    method: 'post',
    data,
  })
}
// --------------------------------------------------------------------------题库
// 新增知识点
export const pointsAdd = (id, data) => {
  return request({
    url: '/classspace/bank/pointsAdd/' + id,
    data,
    method: 'post',
  })
}
// 知识点列表
export const pointsList = (id) => {
  return request({ url: '/classspace/bank/pointsList/' + id, method: 'get' })
}
// 修改知识点
export const pointsUpd = (data) => {
  return request({ url: '/classspace/bank/pointsUpd', data, method: 'post' })
}
// 删除知识点
export const pointsDel = (id) => {
  return request({ url: '/classspace/bank/pointsDel/' + id, method: 'post' })
}

// 修改题目
export const batchUpdateOptions = (data) => {
  return request({
    url: '/classspace/bank/batchUpdateOptions',
    data,
    method: 'post',
  })
}
// 批量删除题目
export const topicAllDel = (params) => {
  return request({
    url: '/classspace/bank/topicAllDel',
    params,
    method: 'post',
  })
}
// 获取知识点下题目列表
export const topicPointsList = (id, data) => {
  return request({
    url: '/classspace/bank/topicPointsList/' + id,
    data,
    method: 'post',
  })
}
// 获取全部题目
export const topicPointsAllList = (id, data) => {
  return request({
    url: '/classspace/bank/topicPointsAllList/' + id,
    data,
    method: 'post',
  })
}
// 添加题目和选项
export const topicAdd = (id, data) => {
  return request({
    url: '/classspace/bank/topicAdd/' + id,
    data,
    method: 'post',
  })
}
// 修改题目和选项
export const topicUpd = (data) => {
  return request({ url: '/classspace/bank/topicUpd', data, method: 'post' })
}
// 题目详情
export const topicDetail = (id, data) => {
  return request({
    url: '/classspace/bank/topicDetail/' + id,
    data,
    method: 'post',
  })
}
